module.exports = __webpack_public_path__ + "img/Money.eb89f5ba.svg";